/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import Header, { HeaderType } from '@/components/Layout/Header/Header';
import './landing.css';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { ContentLayout } from '@/components/Layout';
import resi from '@/assets/prop.png';
import money from '@/assets/mony.png';
import bed from '@/assets/bed1.png';
import bath from '@/assets/bath1.png';
import sqFt from '@/assets/table.png';
import explore from '@/assets/explore.png';
import sb from '@/assets/hm.png';
import eligant from '@/assets/elegant.png';
import hos from '@/assets/hos.png';
import police from '@/assets/police.png';
import mall from '@/assets/mall.png';
import prop from '@/assets/rect.png';
import address from '@/assets/loc-add.png';
import loc from '@/assets/lc.png';
import school from '@/assets/school.png';
import ad from '@/assets/ad.png';
import call from '@/assets/call.png';
import msg from '@/assets/msg.png';
import user from '@/assets/user1.png';
import gallery from '@/assets/gall1.png';
import gallery2 from '@/assets/gall2.png';
import gallery3 from '@/assets/gall3.jpg';
import chat1 from '@/assets/chat2.png';
import i18next from 'i18next';
import town2 from '@/assets/town2.png';
import { Accordion, AccordionDetails, AccordionSummary, Link } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { UseFormRegisterReturn } from 'react-hook-form';
import { Button } from '@/components/Elements';
import { Form, InputField, TextAreaField } from '@/components/Form';
import { InputPhone } from '@/components/Form/InputPhone';
import Slider from 'react-slick';
import { usePropertyForSale } from '@/api/propertyForSale/getPropertyForSale';
import { useAuth } from '@/lib/auth';
import { useNavigate, useParams } from 'react-router-dom';
import PropertyDetail from '@/components/Elements/Loader/PropertyDetail';
import Rentsubcatagories from '@/config/Rentsubcatagories';
import { formatPrice, trimThirty, trimTwenty } from '@/utils/format';
import GoogleMapReact from 'google-map-react';
import RentCatagores from '@/config/RentCatagores';
import { useBusinessDetails } from '@/api/commonDetail/getBusinessDetail';
import { createChat } from '@/api/Chat/createChat';
import { useNotificationStore } from '@/stores/notifications';
import { SendMessage } from '../SendMessage/sendMessage';
import storage from '@/utils/storage';
import { formatAmount } from '../NewHomePage/HomePage';

type FormValues = {
  name: string;
  phone_number: string;
  message: string;
  email: string;
};
export const PropForSale = () => {
  const AnyReactComponent = ({ text }: { text: any }) => <div>{text}</div>;
  const { user } = useAuth();
  const navigate = useNavigate();
  const localAmount = storage.getAmount();
  const localSymbol = storage.getSymbol();
  const { id }: any = useParams();

  // const { data, isLoading } = usePropertyForSale({ id: id ?? '2' });
  const { data, isLoading, refetch } = useBusinessDetails({
    id: id ?? '2',
    customer_id: user?.customer_id ?? '',
  });
  const [show, setShow] = useState(false);

  const [scroll, setScroll] = useState(false);
  const [img1, setImg1] = useState();
  const [img2, setImg2] = useState();
  useEffect(() => {
    window.addEventListener('scroll', () => {
      // setScroll(window.scrollY > 700);

      if (window.scrollY > 700) {
        if (window.scrollY > 1800) {
          setScroll(false);
        } else {
          setScroll(true);
        }
      } else {
        setScroll(false);
      }
    });
  }, []);

  const customerId = data?.data?.customer_id;
  const property = data?.data;
  const [iLat, setiLat] = useState();
  const [iLong, setiLong] = useState();
  useEffect(() => {
    if (property) {
      const parsed_data = property?.image_data;
      setImg1(parsed_data[0]);
      setImg2(parsed_data[1]);

      const parsedLat = parseFloat(property.latitude);
      const parsedLong = parseFloat(property.longitude);

      if (!isNaN(parsedLat) && !isNaN(parsedLong)) {
        setiLat(parsedLat);
        setiLong(parsedLong);
      } else {
        console.error('Invalid latitude or longitude values');
      }
    }
  }, [property]);
  const [loading] = useState(false);
  const settings = {
    dots: true,
    infinite: true,
    //lazyLoad: true,
    // speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 5000,
    //cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slidersettings = {
    dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    // autoplaySpeed: 500,
  };
  console.log(property);
  const category:
    | {
        label: string;
        value: string;
      }
    | undefined = RentCatagores.find((category) => {
    if (category.value == property?.main_category) {
      return category.label;
    }
  });

  const handleChat = async () => {
    try {
      if (!user) {
        useNotificationStore.getState().addNotification({
          title: 'Login',
          type: 'info',
          message: 'Need to Login first!',
        });
        navigate('/auth/login-user');
        return;
      }

      const res: any = await createChat(property?.customer_id);
      navigate(`/user/chat?id=${property?.customer_id}&sid=${res?.twilio_channel_sid}`);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading || loading ? (
        <PropertyDetail />
      ) : (
        <ContentLayout title={i18next.t('Property for Sale')}>
          {/* <BackdropLoader open={loading} /> */}
          <Header type={HeaderType.LANDING} />

          <section className="prop-sale-banner">
            <div className="container">
              {property?.customer_id !== user?.customer_id && (
                <div className="col-12 d-flex justify-content-end pb-4">
                  <Button
                    className="black-btn bg-black"
                    size="sm"
                    disabled={property?.is_requested}
                    onClick={(e) => {
                      if (!user) {
                        useNotificationStore.getState().addNotification({
                          title: 'Login',
                          type: 'info',
                          message: 'Need to Login first!',
                        });
                        navigate('/auth/login-user');
                        return;
                      }
                      setShow(true);
                    }}
                  >
                    Send Message
                  </Button>
                </div>
              )}

              <h2 className="f-50 semi-bold text-black">{property?.title}</h2>
              <p className="pb-3"> {category?.label ?? 'Residential Property'}</p>
              <div className="resi-dential-row">
                <div className="resi-prop-colm">
                  <div className="residential-vol relative">
                    <img className="resident-home" src={img1} alt="home" />
                    {/* <img className="resident-home" src={resi} alt="home" /> */}
                    <div className="total-prop-cont d-flex gap-2">
                      <Link to="" className="prop-ttl-count d-flex align-items-center gap-2">
                        <img src={money} className="prop-ico" />
                        <div className="prop-right-txt">
                          <h6 className="f-16 text-black mb-0">
                            {localSymbol}
                            {formatAmount(formatPrice(property?.price * localAmount))}{' '}
                          </h6>
                          {/* <p className="mb-0">Price nok</p> */}
                        </div>
                      </Link>
                      <Link to="" className="prop-ttl-count d-flex align-items-center gap-2">
                        <img src={sqFt} className="prop-ico" />
                        <div className="prop-right-txt">
                          <h6 className="f-16 text-black mb-0">
                            {formatAmount(property?.property_demension)}
                          </h6>
                          <p className="mb-0">Property dimensions sqft</p>
                        </div>
                      </Link>
                      <Link to="" className="prop-ttl-count d-flex align-items-center gap-2">
                        <img src={bed} className="prop-ico" />
                        <div className="prop-right-txt">
                          <h6 className="f-16 text-black mb-0">
                            {formatAmount(property?.bedrooms)}
                          </h6>
                          <p className="mb-0">Bedroom</p>
                        </div>
                      </Link>
                      <Link to="" className="prop-ttl-count d-flex align-items-center gap-2">
                        <img src={bath} className="prop-ico" />
                        <div className="prop-right-txt">
                          <h6 className="f-16 text-black mb-0">
                            {formatAmount(property?.bathrooms)}
                          </h6>
                          <p className="mb-0">Bathrooms</p>
                        </div>
                      </Link>
                    </div>
                    <div
                      className="property-addressbox"
                      style={{ backgroundImage: 'url(' + prop + ')' }}
                    >
                      <img className="locadd-home" src={loc} alt="loc" />
                      <p className="text-white">
                        {property?.house_number ?? ''} {property?.house_number && ','}{' '}
                        {property?.location}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="resi-prop-right">
                  <div className="explore-add">
                    <img className="resident-explore" src={img2} alt="explore" />
                    {/* <img className="resident-explore" src={explore} alt="explore" /> */}
                    <div
                      className="explore-elegant "
                      style={{ backgroundImage: 'url(' + eligant + ')' }}
                    >
                      <p className="f-16 elegant-title mb-0 text-white text-end">
                        Explore elegance
                      </p>
                      <p className="f-13 text-white elegant-title para text-end">
                        Modern design with a focus on{' '}
                      </p>
                      <div className="explore-details">
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">Property Name</span>
                          <span className="semi-bold explr-no">{property?.property_name}</span>
                        </p>
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">House number</span>
                          <span className="semi-bold explr-no">#{property?.house_number}</span>
                        </p>
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">Location</span>
                          <span className="semi-bold explr-no">
                            {trimThirty(property?.location ?? '')}
                          </span>
                        </p>
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">Postal Code</span>
                          <span className="semi-bold explr-no">{property?.postal_code}</span>
                        </p>
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">Youtube url </span>
                          <span className="semi-bold explr-no">
                            {property?.youtubeUrl ? (
                              <a className="text-light" href={property?.youtubeUrl} target="_blank">
                                {property?.youtubeUrl}
                              </a>
                            ) : (
                              'NA'
                            )}
                          </span>
                        </p>
                        <p className="explore-desc d-flex text-white  flex-wrap mb-0">
                          <span className="explr-hs ">Enter phone number </span>
                          <span className="semi-bold explr-no">{property?.phoneNumber}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prop-apartment">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-5">
                  <div className="apartmetn-list d-flex flex-wrap">
                    {/* <div className="aprrtmet-box">
                      <p className="f-13 mb-0">Developer</p>
                      <p className="f-16 mb-0 semi-bold text-black">Apartment</p>
                    </div> */}
                    <div className="aprrtmet-box">
                      <p className="f-13 mb-0">Reference id</p>
                      <p className="f-16 mb-0 semi-bold text-black">
                        {property?.propertyReferenceId}
                      </p>
                      <span className="f-12">( PR for Residential Property)</span>
                    </div>
                    <div className="aprrtmet-box">
                      <p className="f-13 mb-0">Ready by</p>
                      <p className="f-16 mb-0 semi-bold text-black">{property?.readyBy}</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-7">
                  <div className="loc-facilities">
                    <p className="f-16 mb-1 semi-bold text-black">Facilities</p>
                    <div className="facilities-lisitng d-flex flex-wrap">
                      {property?.facility?.map((i: { name: string; image: string }) => {
                        return (
                          <div className="falitity-div text-center">
                            <img
                              src={i?.image}
                              className="facility-icon m-auto"
                              alt=""
                              width={50}
                            />
                            <p className="facility-txt mt-2 mb-0">{i?.name}</p>
                          </div>
                        );
                      })}

                      {/* <div className="falitity-div text-center">
                        <img src={sb} className="facility-icon m-auto" alt="" />
                        <p className="f-13 mb-0">Climate Control</p>
                      </div>
                      <div className="falitity-div text-center">
                        <img src={sb} className="facility-icon m-auto" alt="" />
                        <p className="f-13 mb-0">Amenities</p>
                      </div>
                      <div className="falitity-div text-center">
                        <img src={sb} className="facility-icon m-auto" alt="" />
                        <p className="f-13 mb-0">Functional Spaces</p>
                      </div>
                      <div className="falitity-div text-center">
                        <img src={sb} className="facility-icon m-auto" alt="" />
                        <p className="f-13 mb-0">Miscellaneous</p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-7 col-xl-8 mt-4">
                  <div className="other-info">
                    <h6 className="f-14 text-black semi-bold">Other Information</h6>
                    <Accordion className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                      >
                        <h6 className="mb-0  semi-bold text-black">Cash Flow Forecast</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.cashflow_forecast}</p>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        {' '}
                        <h6 className="mb-0  semi-bold text-black">Disclaimer</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.disclaimer}</p>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                      >
                        <h6 className="mb-0  semi-bold text-black">Property Information</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.property_information}</p>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                      >
                        <h6 className="mb-0  semi-bold text-black">Required Capital</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.required_capital}</p>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                      >
                        <h6 className="mb-0  semi-bold text-black">Vision</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.vision}</p>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded className="info-acc">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5-content"
                        id="panel5-header"
                      >
                        <h6 className="mb-0  semi-bold text-black">Residental Property</h6>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="f-13 text-black">{property?.residental_property_details}</p>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>

                <div className="col-12 col-lg-5 col-xl-4 mt-4">
                  <div className="finance-box">
                    <h6 className="f-14 text-black semi-bold">Finance</h6>
                    <div className="finance-list">
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Rental</span>
                        <span className="finance-rght">
                          {formatAmount(formatPrice(property?.finance_rental * localAmount))}{' '}
                          {localSymbol}/month
                        </span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Total closing fees </span>
                        <span className="finance-rght">
                          {formatAmount(
                            formatPrice(property?.finance_total_closing_fee * localAmount)
                          )}{' '}
                          {localSymbol}/month
                        </span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Maintance fees</span>
                        <span className="finance-rght">
                          {formatAmount(
                            formatPrice(property?.finance_maintaince_fee * localAmount)
                          )}{' '}
                          {localSymbol}/month
                        </span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Bills and utilities</span>
                        <span className="finance-rght">
                          {formatAmount(formatPrice(property?.finance_bill_utilites * localAmount))}{' '}
                          {localSymbol}
                          /month
                        </span>
                      </p>
                      {/* <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Return on investment nok</span>
                        <span className="finance-rght">
                          {property?.finance_return_on_investment}%
                        </span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Cash flow pkm nok </span>
                        <span className="finance-rght">NOK 10,000/month</span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Finder fees nok </span>
                        <span className="finance-rght">{property?.finance_finder_fee} NOK</span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Potential gross income nok </span>
                        <span className="finance-rght">
                          {property?.finance_potential_gross} NOK/year
                        </span>
                      </p>
                      <p className="finace-list-wrap d-flex flex-wrap">
                        <span className="finance-lft">Rent to landloard nok </span>
                        <span className="finance-rght">
                          {property?.finance_rent_to_landlord} NOK/month
                        </span>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="location-div">
            <div className="container">
              <h6 className="f-16 semi-bold text-black">Location</h6>
              <div className="location-flex d-flex align-items-center gap-2">
                <img src={address} className="location-icon" />
                <p className="f-13 text-black mb-0">
                  {property?.house_number ?? ''} {property?.house_number && ','}{' '}
                  {property?.location}
                </p>
              </div>
              <div className="location-map relative mt-4">
                <div className="loc-mappig">
                  {/* <div
                    className="mapouter"
                    style={{
                      position: 'relative',
                      textAlign: 'right',
                      width: '100%',
                      height: '400px',
                    }}
                  >
                    <div
                      className="gmap_canvas"
                      style={{
                        overflow: 'hidden',
                        background: 'none!important',
                        width: '100%',
                        height: '400px',
                      }}
                    >
                      <iframe
                        className="gmap_iframe"
                        title="Google Map"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight={0}
                        marginWidth={0}
                        src="https://maps.google.com/maps?width=600&height=400&hl=en&q=University of Oxford&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                        style={{ width: '100%', height: '400px' }}
                      ></iframe>
                    </div>
                  </div> */}
                  <div className="map-img-right bg-white rounded-20 shadow p-2 h-75">
                    <div style={{ height: '400px', width: '100%' }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                        defaultCenter={{ lat: iLat, lng: iLong }}
                        defaultZoom={13}
                      >
                        <AnyReactComponent
                          lat={iLat}
                          lng={iLong}
                          text={<i className="fa-sharp fa-solid fa-location-dot googleEarth"></i>}
                        />
                      </GoogleMapReact>
                    </div>
                  </div>
                </div>
                <div className="whats-near">
                  <h6 className="f-14  mb-3 text-black">What’s Nearby</h6>
                  <div className="nreaby-box mb-2">
                    {property?.benefits.map((i) => {
                      return (
                        <div className="near-locations relative">
                          <img src={town2} className="schiil-icon" width={20} />
                          <span>{i}</span>
                          {/* <span className="school-link">1.2 KM</span> */}
                        </div>
                      );
                    })}

                    {/* <div className="near-locations relative">
                      <img src={hos} className="schiil-icon" />
                      <span>Hospital</span>
                      <span className="school-link">2.2 KM</span>
                    </div>
                    <div className="near-locations relative">
                      <img src={police} className="schiil-icon" />
                      <span>Police Station</span>
                      <span className="school-link">1.2 KM</span>
                    </div>
                    <div className="near-locations relative">
                      <img src={mall} className="schiil-icon" />
                      <span>Shopping Mall</span>
                      <span className="school-link">1.2 KM</span>
                    </div>
                    <div className="near-locations relative">
                      <img src={school} className="schiil-icon" />
                      <span>School</span>
                      <span className="school-link">1.2 KM</span>
                    </div> */}
                  </div>
                  {/* <Button className="w-100 bg-black rounded">Get Directions</Button> */}
                </div>
              </div>
            </div>
          </section>
          <section className="request-add">
            <div className="container">
              <div className="row">
                {/* <div className="col-12 col-lg-4">
                  <div className="request-ad-form">
                    <div className="request-ad-head">
                      <h3 className="f-18 semi-bold mb-0">Request for the Ad</h3>
                    </div>
                    <div className="request-ad-content">
                      <div className="request-call-bx d-flex justify-content-between align-items-center">
                        <div className="request-call d-flex align-items-center gap-2">
                          <img src={ad} className="request-io" alt="" />
                          <h4 className="f-14 semi-bold mb-0">Niko Furingee</h4>
                        </div>
                        <div className="call-message d-flex align-items-center gap-3">
                          <Link to="" className="call-link">
                            {' '}
                            <img src={call} className="call-io" alt="" />
                          </Link>
                          <Link to="" className="call-link">
                            {' '}
                            <img src={msg} className="call-io" alt="" />
                          </Link>
                        </div>
                      </div>
                      <p className="or-content relative text-center mt-4">
                        <span className="or-line">Or</span>
                      </p>
                      <p className="text-center f-13 pb-3">Use the form given below</p>
                      <Form<FormValues>
                        onSubmit={async (values) => {
                          alert(JSON.stringify(values, null, 2));
                        }}
                        id="my-form"
                      >
                        {({ register, formState }) => (
                          <>
                            <div className="relative input-start">
                              <InputField
                                label="Your Name"
                                error={formState.errors['name']}
                                registration={register('name')}
                              />
                              <img src={user} className="user-io" alt="" />
                            </div>
                            <div className="relative input-phne mt-0">
                              <InputPhone
                                error={formState.errors['phone_number']}
                                registration={register('phone_number')}
                              />
                             // {/* <img src={user} className="user-io" alt="" /> 
                            </div>
                            <div className="relative input-start mt-0">
                              <InputField
                                type="email"
                                label="Email Address"
                                error={formState.errors['email']}
                                registration={register('email')}
                              />
                              <img src={user} className="user-io" alt="" />
                            </div>
                            <div className="relative input-start mt-0">
                              <TextAreaField
                                label="Message"
                                error={formState.errors['message']}
                                registration={register('message')}
                              />
                              <img src={user} className="user-io" alt="" />
                            </div>
                            <div>
                              <Button type="submit" className="w-full bg-black rounded">
                                Send Request
                              </Button>
                            </div>
                          </>
                        )}
                      </Form>
                    </div>
                  </div>
                </div> */}
                <div className="col-12 col-lg-12">
                  <div className="request-ad-form gallery-request">
                    <h3 className="f-18 semi-bold pb-3">Gallery</h3>
                    <Slider {...settings}>
                      {property?.image_data.map((item: any, index: number) => {
                        return (
                          <div className="gallery-slide-img" key={index}>
                            <img src={item} className="user-io" alt="" />
                          </div>
                        );
                      })}
                      {/* <div className="gallery-slide-img">
                        <img src={gallery} className="user-io" alt="" />
                      </div> 
                       <div className="gallery-slide-img">
                        <img src={gallery2} className="user-io" alt="" />
                      </div>
                      <div className="gallery-slide-img">
                        <img src={gallery3} className="user-io" alt="" />
                      </div>
                      <div className="gallery-slide-img">
                        <img src={gallery} className="user-io" alt="" />
                      </div> */}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* {property?.customer_id !== user?.customer_id && (
            <div className="chat-icon">
              <div onClick={() => handleChat()} className="chat-button-fix pointer">
                <img src={chat1} className="chat-fil" />
              </div>
            </div>
          )} */}
          <SendMessage
            propType="sale_property"
            propId={id}
            userId={property?.customer_id}
            show={show}
            setShow={setShow}
            refetch={refetch}
          />
          <Footer />
        </ContentLayout>
      )}
    </>
  );
};
